module.exports = ["agora mesmo",["%s segundo atrás","%s segundos atrás"],["%s minuto atrás","%s minutos atrás"],["%s hora atrás","%s horas atrás"],["%s dia atrás","%s dias atrás"],["%s semana atrás","%s semanas atrás"],["%s mês atrás","%s meses atrás"],["%s ano atrás","%s anos atrás"]]


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-timeago/locales/pt-BR.json
// module id = Pfka
// module chunks = 1